/**
 * @brisa/ui · BrandLogo
 *
 * Wordmark Brisa Pass — Unbounded Black 900 CAPS, Lilás Bruma sobre Verde.
 */
import * as React from 'react';

export interface BrandLogoProps {
  size?: 'sm' | 'md' | 'lg';
  as?: 'h1' | 'h2' | 'div';
  className?: string;
}

const SIZE_PX: Record<NonNullable<BrandLogoProps['size']>, number> = {
  sm: 32,
  md: 48,
  lg: 72,
};

export function BrandLogo({ size = 'md', as = 'div', className }: BrandLogoProps) {
  const Tag = as as React.ElementType;
  const fontSize = SIZE_PX[size];
  const cls = ['brisa-display', 'brisa-brand-logo', className].filter(Boolean).join(' ');
  return (
    <Tag
      className={cls}
      aria-label="Brisa Pass"
      style={{ fontSize: `${fontSize}px`, color: 'var(--brisa-text)', margin: 0 }}
    >
      Brisa Pass
    </Tag>
  );
}
